module.exports = __webpack_public_path__ + "static/media/pessego.bdf6456c.png";